<template>
  <v-app>
    <v-app-bar 
      app 
      fixed
      dense
      id="bli-navbar"
    >

      <v-app-bar-nav-icon class="hidden-md-and-up" dark @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="headline">
        BLI Tool & Die, Inc.
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items class="hidden-sm-and-down">
        <v-btn text to="/home" exact>Home</v-btn>
        <v-btn text to="/services" exact>Services</v-btn>
        <v-btn text to="/equipment" exact>Equipment</v-btn>
        <v-btn text to="/history" exact>History</v-btn>
        <v-btn text to="/contact" exact>Contact</v-btn>
      </v-toolbar-items>
    </v-app-bar>
    <v-navigation-drawer
      app
      fixed
      v-model="drawer"
      id = "drawer"
    >
       <v-spacer />
       <v-spacer />
       <v-list
          dense
          nav
          class="px-0 py-1"
          id="bli-drawer"
        >
          <v-list-item >
              <div class="headline px-3" style="color:white">
                BLI Tool & Die, Inc.
              </div>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn text to="/home" exact>Home</v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn text to="/services" exact>Services</v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn text to="/equipment" exact>Equipment</v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn text to="/history" exact>History</v-btn>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-btn text to="/contact" exact>Contact</v-btn>
            </v-list-item-content>
          </v-list-item>
       </v-list>
       <v-spacer></v-spacer>
    </v-navigation-drawer>
    <v-content class="pa-1">
      <router-view id="router-view-content"></router-view>
    </v-content>
    <v-footer dense class="pa-3" id="bli-footer">
      <v-spacer></v-spacer>
      <div>Copyright &copy; {{ new Date().getFullYear() }} BLI Tool & Die, Inc.</div>
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</template>

<script>
  export default {
    name: 'app',
    components: {

    },
    data () {
      return {
        drawer: false
      }
    }
  }
</script>

<style src="./index.css"></style>